module.exports = __webpack_public_path__ + "img/4.e25d2836.webp";